import * as MessageManager from '../../SDK/MessageManager'

const Message = {
  state: {
    isShow: false,
    loading: false,
    dynamic_hasMore: true,
    dynamic_params: {
      page_num: 1,
      page_size: 50
    },
    dynamic_list: {},
    msg_lastedId: 0,
    comment_lastedId: 0,
    notice_lastedId: 0,
    comment_hasMore: true,
    comment_params: {
      page_num: 1,
      num_each_page: 20,
      is_need_total: true
    },
    comment_list: {},
    notice_hasMore: true,
    notice_params: {
      limit: 50,
      offset: 0
    },
    notice_list: {},
    isNoticeDetail: false,
    isReloadMsg: false,
    unreadMsg: {},
    cleanSuccess: false
  },
  getters: {
    getMessageLoading: state => state.loading,
    getDynamicHasMore: state => state.dynamic_hasMore,
    getCommentHasMore: state => state.comment_hasMore,
    getNoticeHasMore: state => state.notice_hasMore
  },
  mutations: {
    setCleanSuccess (state, obj) {
      state.cleanSuccess = obj
    },
    setDynamicPageNum (state, obj) {
      state.dynamic_params.page_num = obj
    },
    setCommentPageNum (state, obj) {
      state.comment_params.page_num = obj
    },
    setNoticeOffset (state, obj) {
      state.notice_params.offset = obj
    },
    setMessageLoading (state, obj) {
      state.loading = obj
    },
    setIsReloadMsg (state, obj) {
      state.isReloadMsg = obj
    },
    setDynamicHasMore (state, obj) {
      state.dynamic_hasMore = obj
    },
    setCommentHasMore (state, obj) {
      state.comment_hasMore = obj
    },
    setNoticeHasMore (state, obj) {
      state.notice_hasMore = obj
    },
    getDynamicList (state, obj) {
      state.dynamic_list = obj
      if (obj.content.length < state.dynamic_params.page_size) {
        state.dynamic_hasMore = false
      }
      for (var i = 0; i < obj.content.length; i++) {
        if (obj.content[i].id > state.msg_lastedId) {
          state.msg_lastedId = obj.content[i].id
        }
      }
    },
    getCommentList (state, obj) {
      state.comment_list = obj
      if (obj.commlist.length < state.comment_params.num_each_page) {
        state.comment_hasMore = false
      }
      for (var i = 0; i < obj.commlist.length; i++) {
        if (obj.commlist[i].id > state.comment_lastedId) {
          state.comment_lastedId = obj.commlist[i].id
        }
      }
    },
    getNoticeList (state, obj) {
      state.notice_list = obj
      if (obj.messages.length < state.notice_params.limit) {
        state.notice_hasMore = false
      }
      for (var i = 0; i < obj.messages.length; i++) {
        if (obj.messages[i].id > state.notice_lastedId) {
          state.notice_lastedId = obj.messages[i].id
        }
      }
    },
    setNoticeDetail (state, obj) {
      state.isNoticeDetail = obj
    },
    setUnreadMsg (state, obj) {
      state.unreadMsg = obj
    }
  },
  actions: {
    getDynamicList ({commit, rootState, dispatch}, obj) {
      MessageManager.getDynamicList(rootState.message.dynamic_params).then(response => {
        commit('getDynamicList', response)
        commit('setMessageLoading', false)
        rootState.message.dynamic_params.page_num++
        if (rootState.message.unreadMsg.message_retval > 0) {
          dispatch('setMsgStatus')
        }
      }, err => {
        console.log(err)
      })
    },
    getCommentList ({commit, rootState, dispatch}, obj) {
      MessageManager.getCommentList(rootState.message.comment_params).then(response => {
        commit('getCommentList', response)
        commit('setMessageLoading', false)
        rootState.message.comment_params.page_num++
        if (rootState.message.unreadMsg.comment_retval > 0) {
          dispatch({type: 'setCommentStatus'})
        }
      }, err => {
        console.log(err)
      })
    },
    getNoticeList ({commit, rootState, dispatch}, obj) {
      MessageManager.getNoticeList(rootState.message.notice_params).then(response => {
        commit('getNoticeList', response)
        commit('setMessageLoading', false)
        rootState.message.notice_params.offset += rootState.message.notice_params.limit
        if (rootState.message.unreadMsg.notice_retval > 0) {
          dispatch({type: 'setNoticeStatus'})
        }
      }, err => {
        console.log(err)
      })
    },
    getRedpoint ({commit, rootState}, obj) {
      MessageManager.getRedpoint().then(response => {
        commit('setUnreadMsg', response)
      }, err => {
        console.log(err)
      })
    },
    setMsgStatus ({commit, rootState, dispatch}, obj) {
      let params = {logId: rootState.message.msg_lastedId}
      MessageManager.setMsgStatus(params).then(response => {
        dispatch({type: 'getRedpoint'})
      }, err => {
        console.log(err)
      })
    },
    setCommentStatus ({commit, rootState, dispatch}, obj) {
      let params = {lastedId: rootState.message.comment_lastedId}
      MessageManager.setCommentStatus(params).then(response => {
        dispatch({type: 'getRedpoint'})
      }, err => {
        console.log(err)
      })
    },
    setNoticeStatus ({commit, rootState, dispatch}, obj) {
      let params = {lastedId: rootState.message.notice_lastedId}
      MessageManager.setNoticeStatus(params).then(response => {
        dispatch({type: 'getRedpoint'})
      }, err => {
        console.log(err)
      })
    },
    cleanMsg ({commit}, obj) {
      MessageManager.cleanMsg().then(response => {
        commit('setCleanSuccess', true)
        commit('setIsReloadMsg', true)
      }, err => {
        console.log(err)
      })
    },
    cleanComment ({commit}, obj) {
      MessageManager.cleanComment().then(response => {
        commit('setCleanSuccess', true)
        commit('setIsReloadMsg', true)
      }, err => {
        console.log(err)
      })
    }
  }
}
export default Message



// WEBPACK FOOTER //
// ./src/store/modules/message.js